import { Google, Pixall } from '../analytics/index.js';
import { getInventoryOwnerById } from '../utilities/index.js';
import { inventoryTransformer as googleInventoryTransformer } from '../transformers/google/index.js';
/**
 * @summary Sends Google event for Electric Vehicle Info link on Fuel Type Filter SRP click
 */
export async function electricVehicleFilterInfoClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    label
  } = metadata.data;
  Google.sendClickEvent({
    eventElement: 'search-car',
    eventResult: `text-link::${label}`
  }, option);
  return {};
}

/**
 * @summary Sends Google event for Electric Vehicle Research Article in Electric Info Model
 */
export async function electricVehicleResearchArticleClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  const {
    label
  } = metadata.data;
  Google.sendClickEvent({
    eventElement: 'research',
    eventResult: `text-link::editorial::${label}`
  }, option);
  return {};
}

/**
 * @summary Sends Google and Pixall event for Electric vehicle charge time CTA click
 */
export async function electricVehicleChargeTimeCTAClick(metadata, option) {
  if (option === void 0) {
    option = {};
  }
  const {
    data = {},
    dataLayer = {},
    state
  } = metadata;
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  const pixallFuelTypeCode = {
    Electric: 'ele',
    'Hybrid Gas/Electric': 'hyb'
  };
  const gaFuelTypeCode = {
    Electric: 'electric',
    'Hybrid Gas/Electric': 'plug-in-hybrid'
  };
  Google.sendClickEvent({
    eventElement: `vdp_${inventory.listingType?.toLowerCase()}`,
    eventResult: `text-link::dealer-battery-info::${gaFuelTypeCode[inventory.fuelType?.name]}`,
    eventNonInteractive: true,
    eventData: {
      vehicle: googleInventoryTransformer(inventory, {
        target: 'vehicle',
        dataLayer
      })
    }
  }, option);
  Pixall.sendClickEvent({
    eventSource: 'vehicle',
    eventType: 'click',
    pageType: 'vdp',
    pageId: 'fyc_vdp',
    label: `dri_bttry_info_${pixallFuelTypeCode[inventory.fuelType?.name]}`,
    inventory
  }, dataLayer, option);
  return {};
}

/**
 * @summary Sends Pixall click event for VDP View Details - Battery Degradation
 * @events event 150
 */
export async function electricVehicleViewDetailsBatteryDegradationClick(metadata, option) {
  if (metadata === void 0) {
    metadata = {};
  }
  if (option === void 0) {
    option = {};
  }
  const {
    data = {},
    dataLayer = {},
    state
  } = metadata;
  const {
    inventoryId
  } = data;
  const inventory = getInventoryOwnerById(state, inventoryId);
  Pixall.sendClickEvent({
    eventSource: 'link',
    eventType: 'click',
    pageType: 'vdp',
    pageId: 'fyc_vdp',
    label: 'text-link::view-details',
    inventory
  }, dataLayer, option);
  return {};
}
export default {
  electricVehicleFilterInfoClick,
  electricVehicleResearchArticleClick,
  electricVehicleChargeTimeCTAClick,
  electricVehicleViewDetailsBatteryDegradationClick
};